import CandidateHelper from './models/CandidateHelper';

export default { candidates: CandidateHelper };
